import { type FC, useEffect, useState } from "react";
import { css } from "@stubhub/broadway-foundation/css";
import { Heading } from "@stubhub/broadway-web";
import { useAppContext } from "src/shared/context/AppContext";

// Days of week are hardcoded in English — this experiment targets SH US English only
const DAYS_OF_WEEK = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const greetingStyle = css({
  textAlign: "center",
  color: "text",
  marginBlockStart: "primitives.150",
  marginBlockEnd: "primitives.200",
});

/**
 * Homepage greeting for TMSearchAiCommerceChat search experience.
 */
export const HomeAiGreeting: FC = () => {
  const appContext = useAppContext();
  // Defer day resolution to the client to avoid SSR/client timezone mismatch
  const [dayOfWeek, setDayOfWeek] = useState<string | null>(null);
  useEffect(() => {
    setDayOfWeek(DAYS_OF_WEEK[new Date().getDay()] ?? null);
  }, []);

  if (!appContext.userFirstName || !dayOfWeek) return null;
  return (
    <Heading as="h2" variant="header" size="medium" className={greetingStyle}>
      {`Happy ${dayOfWeek}, ${appContext.userFirstName}`}
    </Heading>
  );
};
